import {
  Create,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
} from "react-admin";

export const GroupCreate = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("groups.create") ||
      permissions.includes("groups.*") ||
      permissions.includes("*")
    )
  )
    return null;

  return (
    <Create title="Create Group" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Group created successfully", { type: "success" })
        }
      >
        <TextInput source="name" />
        <TextInput source="description" />
      </SimpleForm>
    </Create>
  );
};